module.exports = __webpack_public_path__ + "img/hsia-category.a784b3fd.webp";